import { Injectable } from "@angular/core";
import { EncuestaDTO, ItemPreguntaDTO, PreguntaDTO } from "@DTOS";
import { PreguntaModelDTO } from "@Models";
import { EncuestasService } from "../../encuestas.service";

@Injectable({
    providedIn: "root"
})
export class TiposPreguntasService {
    public preguntaModel: PreguntaModelDTO;
    public encuesta: EncuestaDTO;

    public colores = {
        SINGLE_CHOICE: "#ee7bb5",
        MULTIPLE_CHOICE: "#8cd7f9",
        NUMERIC_IN_RANGE: "#c38ac1",
        TEXT: "#fdbe71",
        NUMERIC_TEXT: "#fdbe71",
        INFO: "#8b31d1",
        PICTURE: "#7c8ecd",
        MATRIX_SINGLE: "#D192F9",
        MATRIX_MULTIPLE: "#D9F38F",
        MATRIX_RANGE: "#5E72D6",
        EXTRA_POINTS: "#85bb65",
        DISTRIBUTION: "#9b4f4f",
        SCANNER: "#54a8ef",
        DATE_SELECT: "#32a14f",
        RANKING: "#009988",
        URL: "#70ECC4",
        FLOW_GROUP: "#fdbe71",
        FLOW_CHECKPOINT: "#a9c2b3",
        FLOW_JUMP: "#85bb65",
        FLOW_RANDOM: "#85bb65",
        VIDEO: "#EA6C4E",
        GRAPHICAL_CHOICE: "#d3a855"
    };

    constructor(private encuestasService: EncuestasService) {}

    public async guardarPregunta(pregunta: PreguntaDTO): Promise<PreguntaDTO> {
        return this.encuestasService.guardarPregunta(this.encuesta, pregunta);
    }

    public async agregarSubpreguntaPregunta(pregunta: PreguntaDTO, subpregunta: PreguntaDTO): Promise<PreguntaDTO> {
        return this.encuestasService.agregarSubpreguntaPregunta(this.encuesta, pregunta, subpregunta);
    }

    public async guardarSubpreguntaPregunta(subpregunta: PreguntaDTO): Promise<PreguntaDTO> {
        return await this.encuestasService.guardarSubpreguntaPregunta(this.encuesta, subpregunta);
    }

    public async borrarSubpreguntaPregunta(pregunta: PreguntaDTO, subpregunta: PreguntaDTO): Promise<void> {
        await this.encuestasService.borrarSubpreguntaPregunta(this.encuesta, pregunta, subpregunta);
    }

    public async agregarItemPregunta(pregunta: PreguntaDTO, item: ItemPreguntaDTO): Promise<ItemPreguntaDTO> {
        return await this.encuestasService.agregarItemPregunta(this.encuesta, pregunta, item);
    }

    public async guardarItemPregunta(pregunta: PreguntaDTO, item: ItemPreguntaDTO): Promise<ItemPreguntaDTO> {
        return await this.encuestasService.guardarItemPregunta(this.encuesta, pregunta, item);
    }

    public async borrarItemPregunta(pregunta: PreguntaDTO, item: ItemPreguntaDTO): Promise<void> {
        await this.encuestasService.borrarItemPregunta(this.encuesta, pregunta, item);
    }
}
